<div class="faq bg-white text-primary ptb-15 pse-10 border-radius-10">
    <div class="question size-7 weight-700 d-flex justify-content-between">
      <div class="d-flex align-items-center w-100">
        <div class="circle w-100 max-10 bg-primary rounded-circle mre-5"></div>
        <div>{{ question }}</div>
      </div>
      <div><img class="faq-arrow" src="../../../../assets/images/Iconionic-ios-arrow-back.svg" alt="icon" /></div>
    </div>
    <div class="answer size-7 lh-lg" [innerHTML]=" answer ">
    </div>
  </div>

